// Coral taxonomy for Exotic Reefing Inc
export const CORAL_TAXONOMY = [
  { type: "SPS", label: "SPS", subtypes: ["Acroporas", "Birdsnests", "Montiporas", "Stylophora"] },
  {
    type: "LPS",
    label: "LPS",
    subtypes: [
      "Acans", "Blastos", "Brains", "Chalices", "Duncans", "Elegances", "Scolys",
      "Encrusting LPS", "Euphyllias", "Flavias", "Fungia Plates", "Gonioporas", "Trumpets",
    ],
  },
  { type: "Anemones", label: "Anemones", subtypes: [] },
  { type: "Soft Corals", label: "Soft Corals", subtypes: ["Leather Corals", "Mushrooms", "Zoas"] },
];

export const CORAL_TYPES = CORAL_TAXONOMY.map((c) => c.type);

const SUBTYPE_LABELS = {
  Euphyllias: "Euphyllias (Frogspawns · Hammers · Torches)",
};
export const subtypeLabel = (s) => SUBTYPE_LABELS[s] || s;

export const subtypesFor = (type) =>
  (CORAL_TAXONOMY.find((c) => c.type === type)?.subtypes) || [];

export const FISH_TYPES = [
  "Clownfish (Bred)", "File Fish", "Foxface & Rabbitfish", "Puffers", "Seahorses",
  "Angelfish", "Anthias", "Blennies", "Butterflyfish", "Cardinalfish", "Damselfish",
  "Gobies", "Groupers", "Hawkfish", "Tangs", "Triggerfish", "Wrasses", "Shrimps",
];

export const EQUIPMENT_TYPES = [
  "Fish Tank", "Protein Skimmer", "Return Pump", "Doser", "Power Head",
  "Apex / Neptune System", "Reservoir", "Frag Rack", "Quarantine Box", "Fish Trap",
  "UV Light", "Heater", "Bio Reactor", "Reef Light", "Red Sea Reef Mat", "Kalkwasser",
];

export const EQUIPMENT_CONDITIONS = [
  { value: "new", label: "New" },
  { value: "used", label: "Used" },
];
